// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"32c535b0","295":"80db80d2","381":"cf3be8ff","607":"4bec3d45","635":"4f2fcf6e","891":"f89265b3"}[chunkId] + ".chunk.js";
};